import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("mimaso_sid");
  if (!sid) {
    sid = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("mimaso_sid", sid);
  }
  return sid;
}

export default function Tracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't track admin / internal document pages
    if (pathname.startsWith("/admin")) return;
    api.post("/track", { path: pathname, session_id: getSessionId() }).catch(() => {});
  }, [pathname]);

  return null;
}
